import { render, staticRenderFns } from "./ActivationCardRecuringPrice.vue?vue&type=template&id=6bed282c&scoped=true"
import script from "./ActivationCardRecuringPrice.vue?vue&type=script&lang=ts"
export * from "./ActivationCardRecuringPrice.vue?vue&type=script&lang=ts"
import style0 from "./ActivationCardRecuringPrice.vue?vue&type=style&index=0&id=6bed282c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bed282c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bed282c')) {
      api.createRecord('6bed282c', component.options)
    } else {
      api.reload('6bed282c', component.options)
    }
    module.hot.accept("./ActivationCardRecuringPrice.vue?vue&type=template&id=6bed282c&scoped=true", function () {
      api.rerender('6bed282c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/ActivationCardRecuringPrice.vue"
export default component.exports